<!-- 
    Content-only section. 
    Introduction to report.
    Requires an anchor #start
-->
<template>
  <v-layout justify-space-between wrap class="pa-0 pb-2 encode">
    <v-flex md7 xs10>
      <div class="encode title font-weight-black pb-3 pt-2">RESILIENT RESIDENCE</div>
    </v-flex>
    <v-flex md7 xs10>
      <div class="encode display-1 font-weight-black pb-3">Your Resilient Residence Report</div>
    </v-flex>
    <v-flex md7 xs10 class="pb-2">
      The purpose of this report is to identify specific actions
      that you can take to strengthen your home against cyclones. Please use this report as a resource to make your
      home as cyclone resistant as possible. Contact a licenced contractor to plan your repairs and to ensure
      your home is ready for high winds.
    </v-flex>
    <!--
    <v-flex md7 xs10 pt-2 pb-0 justify-center text-xs-center>
      <v-btn
        class="mt-2 blue-text yellow-background"
        dark
        large
        round
        to='download'
      >View</v-btn>
    </v-flex>
    -->
  </v-layout>
</template>

<style scoped>
@import "../assets/styles/styles.css";
</style>

<script>
export default {
  name: "ReportHeader"
};
</script>
